import PropTypes from "prop-types";

const Header = ({ title }) => {
  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=Adminn`;

  return (
    <div>
      <header className="flex justify-between items-center mb-6 font-sora mt-8 md:mt-0">
        <div>
          <h1 className="md:text-3xl md:top-0 p-4 text-black font-semibold">{title}</h1>
        </div>
        <div className="flex items-center">
          <span className="mr-4">Welcome, <b className="text-secondary">Admin</b></span>
          <img src={avatarUrl} alt="User Avatar" className="h-10 w-10 rounded-full" />
        </div>
      </header>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
